// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/(client)/create": [17,[3]],
		"/(client)/direct": [18,[3,5]],
		"/(client)/direct/create": [20,[3,5]],
		"/(client)/direct/[roomIdOrAlias]/[[eventId]]": [19,[3,5]],
		"/(client)/explore": [21,[3,6]],
		"/(client)/explore/featured": [23,[3,6]],
		"/(client)/explore/[server]": [22,[3,6]],
		"/(client)/home": [24,[3,7]],
		"/(client)/home/create": [26,[3,7]],
		"/(client)/home/join": [27,[3,7]],
		"/(client)/home/search": [28,[3,7]],
		"/(client)/home/[roomIdOrAlias]/[[eventId]]": [25,[3,7]],
		"/(client)/inbox": [29,[3,8]],
		"/(client)/inbox/invites": [30,[3,8]],
		"/(client)/inbox/notifications": [31,[3,8]],
		"/(auth)/login/[[server]]": [10,[2]],
		"/(auth)/register/[[server]]": [11,[2]],
		"/(auth)/reset-password/[[server]]": [12,[2]],
		"/(client)/[spaceIdOrAlias]": [13,[3,4]],
		"/(client)/[spaceIdOrAlias]/lobby": [15,[3,4]],
		"/(client)/[spaceIdOrAlias]/search": [16,[3,4]],
		"/(client)/[spaceIdOrAlias]/[roomIdOrAlias]/[[eventId]]": [14,[3,4]],
		"/[...notFound]": [32]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);